import { commonDateOptions } from "@/src/constants/filterConstants.js";

export const codeReviewerSteps = {
  CONNECT: "connect",
  DASHBOARD: "dashboard",
};

export const providers = {
  GITHUB: "github",
  GITLAB: "gitlab",
  BITBUCKET: "bitbucket",
};

export const providerLabels = {
  [providers.GITHUB]: "GitHub",
  [providers.GITLAB]: "GitLab",
  [providers.BITBUCKET]: "Bitbucket",
};

export const providerBaseUrls = {
  [providers.GITHUB]: "https://github.com",
  [providers.GITLAB]: "https://gitlab.com",
  [providers.BITBUCKET]: "https://bitbucket.org",
};

export const providerPrPaths = {
  [providers.BITBUCKET]: "pull-requests",
  default: "pull",
};

export const datePresets = {
  THIS_MONTH: "this_month",
  ALL_TIME: "all_time",
  CUSTOM: "custom",
};

export const githubPopup = {
  NAME: "github-app-install",
  OPTIONS: "width=600,height=700",
};

export const reviewerApiPaths = {
  INSTALL_GITHUB: "/install/github",
  INTEGRATIONS: "/integrations",
  ORGANIZATIONS: "/organizations",
  CODE_REPOSITORIES: "/code-repositories",
  REVIEWS: "/reviews",
  REVIEW_STATS: "/reviews/stats",
};

export const reviewColumnKeys = {
  PR_TITLE: "pr_title",
  PR_STATUS: "pr_status",
  AUTHOR_HANDLE: "author_handle",
  ISSUES: "issues",
  CREATED_AT: "created_at",
  ACTIONS: "actions",
};

export const reviewsTableHeaders = [
  { label: "Pull Request", key: reviewColumnKeys.PR_TITLE, width: 150 },
  { label: "Status", key: reviewColumnKeys.PR_STATUS, width: 100 },
  { label: "Author", key: reviewColumnKeys.AUTHOR_HANDLE, width: 100 },
  { label: "Issues", key: reviewColumnKeys.ISSUES, width: 70 },
  { label: "Date", key: reviewColumnKeys.CREATED_AT, width: 120 },
  { label: "", key: reviewColumnKeys.ACTIONS, fixWidth: 50, ellipsis: false },
];

export const statCards = [
  { key: "total_reviews", label: "PR's Reviewed", chartSource: "reviews_over_time", chartType: "bar", chartLabel: "PRs Reviewed" },
  {
    key: "total_issues_raised",
    label: "Issues Found",
    chartViews: [
      { id: "category", label: "By Category", chartSource: "issues_by_category_over_time", chartType: "stacked_bar", chartLabel: "Issues by Category", colorMap: "category" },
      { id: "severity", label: "By Severity", chartSource: "issues_by_severity_over_time", chartType: "stacked_bar", chartLabel: "Issues by Severity", colorMap: "severity" },
    ],
  },
  { key: "unique_authors", label: "Users" },
  { key: "issues_resolved", label: "Issues Resolved", chartSource: "resolved_by_category_over_time", chartType: "stacked_bar", chartLabel: "Issues Resolved" },
];

export const severityChartColors = {
  high: "#EF4444",
  medium: "#F59E0B",
  low: "#3B82F6",
};

export const issueCategoryColors = {
  logic: "#EF4444",
  security: "#F97316",
  concurrency: "#A146E8",
  "error-handling": "#E879F9",
  "resource-leak": "#48AF7D",
  "type-safety": "#2579EF",
  performance: "#D89435",
  "api-contract": "#6B7280",
};

export const prStatusLabels = {
  open: "Open",
  merged: "Merged",
  closed: "Closed",
};

export const accountStatus = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
};

export const accountStatusLabels = {
  [accountStatus.CONNECTED]: "Connected",
  [accountStatus.DISCONNECTED]: "Disconnected",
};

export const getAccountStatus = (account) => {
  if (account.is_active !== false) return accountStatus.CONNECTED;
  return accountStatus.DISCONNECTED;
};

export const accountColumnKeys = {
  ACCOUNT_ID: "account_id",
  STATUS: "status",
  REPO_COUNT: "repo_count",
  IS_PRIMARY: "is_primary",
};

export const accountsTableHeaders = [
  { label: "Github Account", key: accountColumnKeys.ACCOUNT_ID, width: 200 },
  { label: "Status", key: accountColumnKeys.STATUS, width: 150 },
  { label: "Repositories Synced", key: accountColumnKeys.REPO_COUNT, width: 150 },
  { label: "", key: accountColumnKeys.IS_PRIMARY, width: 100 },
];

export const codeReviewerDefaultViews = {
  active: [
    { id: 1, name: "All", filters: {} },
    { id: 2, name: "Open", filters: { pr_status: "open" } },
    { id: 3, name: "Merged", filters: { pr_status: "merged" } },
  ],
  inactive: [],
  current: { id: 1, name: "All", filters: {} },
};

export const codeReviewerFilters = [
  {
    id: "repo_id",
    name: "Repository",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "author_handle",
    name: "Author",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
];

export const issueCategoryOptions = Object.keys(issueCategoryColors).map((key) => ({
  id: key,
  name: key.charAt(0).toUpperCase() + key.slice(1),
}));

export const severityOptions = [
  { id: "high", name: "High" },
  { id: "medium", name: "Medium" },
  { id: "low", name: "Low" },
];

export const codeReviewerDashboardFilters = [
  {
    id: "date",
    name: "Date",
    options: commonDateOptions,
    searchable: false,
    multiSelect: false,
    showInitials: false,
  },
  {
    id: "repo_id",
    name: "Repository",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "category",
    name: "Category",
    options: issueCategoryOptions,
    searchable: false,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "severity",
    name: "Severity",
    options: severityOptions,
    searchable: false,
    multiSelect: true,
    showInitials: false,
  },
];
